import React from 'react';
// import { useHistory } from 'react-router';
// import ReactGA from 'react-ga';
import Sponsors from '../Sponsors/Sponsors';
import About from '../About/About';
import CountDown from '../../components/Countdown/CountDown';
import SpeakersContainer from '../Speakers/Speakers';
import Hosts from '../Hosts/Hosts';
import './Home.scss';
import PrivacySection from '../PrivacySection/PrivacySection';

const Home = () => {
  // const history = useHistory();
  // const onRegisterClick = () => {
  //   if (document.cookie.replace(/(?:(?:^|.*;\s*)ga_gdpr\s*=\s*([^;]*).*$)|^.*$/, '$1') === 'yes') {
  //     ReactGA.event({
  //       category: 'Button',
  //       action: 'Clicked Register Now button'
  //     });
  //   }
  // };

  return (
    <div id="home-section">
      <div className="container">
        <div className="home">
          <div />
          <div className="home-middle">
            <div className="home-middle-first-row">
              <div className="middle-year-left">2021</div>
              <div className="logo"> </div>
              <div className="middle-year-right">2021</div>
            </div>
            <div className="home-middle-second-row">
              <div className="info-icons">
                <i className="fas fa-calendar-alt icon" />
              </div>
              <div className="info-text">
                <div>October 19-21, 2021</div>
              </div>
            </div>
            <div className="home-middle-third-row">
              <CountDown
                afterDateMessage=""
                givenDate={new Date('Oct 19 2021 15:00:00')}
                title=""
              />
            </div>
            <div className="home-middle-third-row">
              {/* <a
                className="button is-large"
                href="https://cvent.me/qMbaql?RefId=web"
                id="cfs-button"
                rel="noopener noreferrer"
                target="_blank">
                Request late access
              </a> */}
              {/* <button
                className="button is-large"
                id="cfs-button"
                onClick={() => history.push('/cfs')}
                type="button">
                Call for Speakers
              </button> */}
              {/* <button
                className="button is-large"
                id="cfs-button"
                onClick={() => history.push('/ff')}
                type="button">
                Feedback Form
              </button> */}
            </div>
            {/* <div className="home-middle-third-row">
              <p>
                Watch OpenSlava 2021 online via{' '}
                <a
                  href="https://virtualshowfloor.cloud/auth/login?event=Openslava2021"
                  rel="noreferrer"
                  target="_blank">
                  Virtual Showfloor
                </a>
                {' or '}
                <a href="https://youtu.be/ks5zlcyPjzk" rel="noreferrer" target="_blank">
                  YouTube
                </a>
              </p>
            </div> */}
          </div>
          <div className="home-bottom">
            <div className="home-bottom-left">
              <span>ACCENTURE CONFERENCE ON</span>
              <span className="bold-text">EMERGING TECHNOLOGIES</span>
              <span className="bold-text">AND OPEN SOURCE</span>
            </div>
            <div className="home-bottom-right">
              <div className="info-icons">
                <i className="fas fa-calendar-alt icon" />
              </div>
              <div className="info-text">
                <span>October 19-21, 2021</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <About />
      <SpeakersContainer />
      <Hosts />
      <Sponsors />
      <PrivacySection />
    </div>
  );
};

export default Home;
